module.exports = __webpack_public_path__ + "client side dental2.svg?d9b252bac68325249ec20473bfb94bfb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/client side dental2.svg
// module id = 34
// module chunks = 0